<template>
  <div class="cont"><div ref="chartLine" class="linsty" /></div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      echart: "",
      timeStr: "", // 时间
      dataLabel: "", // 查看当前项
      unit: "", // 当前数据的单位
      titleData: "", // 表格标题
      timeList: [], // 时间列表
      dataList: [] // 数据列表
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    updataTable() {
      this.echart.resize();
    },

    // 初始化图表
    initChart(dataList, dataLabel, unit, colorFlag, timeStr) {
      this.dataList = dataList;
      this.titleData = timeStr;
      this.dataLabel = dataLabel;
      this.timeStr = timeStr;
      this.unit = unit;
      let titleColor = "#55A2F2";
      // 判断设备是否离线 是否已经离线：hasOffline，true已离线,false:未离线
      if (colorFlag) {
        titleColor = "red";
        this.titleData = this.titleData + "(离线)";
      }

      this.echart = echarts.init(this.$refs.chartLine, "blueskin");

      var option = {
        title: {
          text: timeStr,
          x: "center",
          y: "10px",
          textStyle: {
            color: titleColor,
            fontSize: 16,
            fontWeight: "100"
          }
        },
        tooltip: {
          formatter: e => {
            return (
              this.timeStr +
              ` ${e[0].name}时<br/>${e[0].seriesName}：${e[0].value + " "}${
                this.unit
              }`
            );
          },
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            // 网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#e4f4f4",
                width: 1,
                type: "solid"
              }
            },
            type: "category",

            axisLabel: {
              textStyle: {
                color: "#76b9e0",
                fontSize: 14
              }
            },
            axisLine: {
              lineStyle: {
                color: "#76b9e0",
                width: 2
              }
            },

            data: this.timeList
          }
        ],
        yAxis: [
          {
            // 网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#e4f4f4",
                width: 1,
                type: "solid"
              }
            },
            type: "value",
            name: "单位: " + (this.unit || ""),
            axisLabel: {
              textStyle: {
                color: "#76b9e0",
                fontSize: 14
              }
            },
            axisLine: {
              lineStyle: {
                color: "#76b9e0",
                width: 2
              }
            }
          }
        ],
        series: [
          {
            name: this.dataLabel,
            type: "line",
            smooth: true, // 这句就是让曲线变平滑的
            areaStyle: {
              normal: {
                color: "#E5F1FD" // 改变区域颜色
              }
            },
            itemStyle: {
              normal: {
                color: "#55A2F2", // 改变折线点的颜色
                lineStyle: {
                  color: "#55A2F2"
                }
              }
            },
            data: this.dataList,
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" }
              ]
            }
          }
        ]
      };
      this.echart.setOption(option);
      this.$forceUpdate();
    }
  }
};
</script>

<style>
.linsty {
  min-width: 900px;
  min-height: 500px;
}
.cont {
  width: 98%;
}
</style>
